import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const forbiddenSearchSchema = z.object({
    from: z.string().optional()
});
export const Route = createFileRoute('/403')({
    validateSearch: forbiddenSearchSchema,
    component: ForbiddenPage
});
function ForbiddenPage() {
    const { from } = Route.useSearch();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex min-h-screen flex-col items-center justify-center gap-6 p-4",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-6xl font-bold text-destructive",
                children: "403"
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "text-xl font-semibold",
                children: "Access Denied"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "text-muted-foreground text-center max-w-md",
                children: [
                    "You don't have permission to access this page.",
                    from ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-sm font-mono",
                                children: from
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(Link, {
                to: "/",
                className: "text-primary underline hover:no-underline",
                children: "Back to Home"
            })
        ]
    });
}
